import axios from 'axios';

// GET /admin/candidate/:id/pdp -> PDF blob; triggers a browser download.
// On a 4xx (e.g. candidate has no completed assessment) the body is a JSON error blob —
// parse it and throw a readable message so the UI can show it (never a broken download).
export const generatePdp = async (candidateId, label) => {
  try {
    const params = label ? { label } : {};
    const res = await axios.get(`/admin/candidate/${candidateId}/pdp`, {
      params,
      responseType: 'blob',
    });

    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const cd = res.headers['content-disposition'] || '';
    const match = cd.match(/filename="?([^"]+)"?/);
    a.download = match ? match[1] : `pdp-${candidateId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    let message = 'Failed to generate the PDP report.';
    const data = err.response && err.response.data;
    if (data && typeof data.text === 'function') {
      try {
        const json = JSON.parse(await data.text());
        message =
          json.status_message ||
          json.message ||
          (json.errors && json.errors[0] && json.errors[0].msg) ||
          message;
      } catch (e) {
        /* keep default message */
      }
    }
    throw new Error(message);
  }
};
